import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef, useState } from "react";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { renderInformationItem } from "../productRequestPage/detail";
import { Blog } from "./type";
import "./style.scss"
import { imageUrl } from "../../services/urls";
import { HtmlEditor, ScrollView } from "devextreme-react";
const BlogDetail = forwardRef<any, { data: Blog }>((
    { data }, ref
) => {
    const localize = useSelector(getLocalized);
    const [scrollDatas] = useState({
        showScrollBarMode: 'onScroll',
        pullDown: false,
        scrollByContent: true,
        scrollByThumb: true,
    });
    return <Form
        formData={data}
        ref={ref}
    >
        <GroupItem>
            <SimpleItem
                render={(e: any) => {
                    return <div className="blog-image">
                        <img src={imageUrl + data.Image} alt="">
                        </img>
                    </div>
                }}
            >

            </SimpleItem>
            <SimpleItem
                dataField={"Name"}
                label={{
                    text: localize.getString("name"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem
                label={{
                    text: localize.getString("blogTags"),
                }}

                render={(e: any) => {
                    return <div className="blog-tags">
                        {
                            data?.BlogTags?.map((item: any) => {
                                return <div >
                                    <div className="blog-tags-item">{item.Name} </div>
                                </div>
                            })
                        }
                    </div>
                }}
            ></SimpleItem>
            <SimpleItem
                dataField={"ProductCategoryName"}
                label={{
                    text: localize.getString("category"),
                }}
                render={renderInformationItem}
            >
            </SimpleItem>
            <SimpleItem

                label={{
                    text: localize.getString("content"),
                }}
                render={(e: any) => {
                    return <ScrollView
                        scrollByContent={scrollDatas.scrollByContent}
                        scrollByThumb={scrollDatas.scrollByThumb}
                        showScrollbar={"onScroll"}
                        bounceEnabled={scrollDatas.pullDown}
                        height={400}
                    >
                        <div className="blog-content">
                            <HtmlEditor value={data.Content} disabled={true}/>
                        </div>
                    </ScrollView>

                }}
            >
            </SimpleItem>
        </GroupItem>
    </Form>
})

export default BlogDetail